import React, { useEffect, useState } from 'react'

const ONE_DAY_MS = 86400000

function formatDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

function formatCountdown(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

type Props = {
  endDate: string
  className?: string
}

const CategoryCountdown = ({ endDate, className }: Props) => {
  const end = new Date(endDate).getTime()
  const [remaining, setRemaining] = useState(() =>
    Math.max(0, end - Date.now()),
  )

  useEffect(() => {
    const interval = setInterval(() => {
      const r = Math.max(0, end - Date.now())
      setRemaining(r)
      if (r === 0) clearInterval(interval)
    }, 1000)
    return () => clearInterval(interval)
  }, [end])

  if (remaining <= 0) return null

  const base = className || 'category-countdown'

  if (remaining > ONE_DAY_MS) {
    return (
      <span className={`${base} ${base}--date`}>
        {formatDate(new Date(endDate))}
      </span>
    )
  }

  return (
    <span className={`${base} ${base}--live`}>
      {formatCountdown(remaining)}
    </span>
  )
}

export default CategoryCountdown
